import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../../../assets/scss/vendor_scss/signup.scss";
import "../../../assets/scss/components/home.scss";
import NuvamaWhiteLogo from "../../../assets/images/nuvama-white-logo.svg";
import VendorSignup from "../../../components/VendorComponents/VendorSignup/VendorSignup";
import { SIGNUP_FORM } from "./signupConstensts";
import { vendorSignFormSubmit } from "../../../services/Signup/SignupApiServices";
import {
  removeServerErrors,
  constants,
  keyClockclient,
  errorsMsg,
} from "../../Constants/commenFeatures";
import ErrorMsg from "../../../components/CommonCompnents/ErrorMsg";
import { RoutesUrl } from "../../Routes/constents";
import { getServerKey } from "../../../services/encription/encriptionServices";
import {
  decryption,
  encryption,
  hashingFeatures,
} from "../../../services/encription/encryption";

const Signup: React.FC = (props) => {
  const history = useHistory();
  const location = useLocation();
  const getQueryParams = location.search
    ? window.atob(location.search.split("?")[1])
    : "";
  const getMailId = getQueryParams ? getQueryParams.split("?")[0] : "";
  const getLeadId = getQueryParams ? getQueryParams.split("?")[1] : "";
  const getName = getQueryParams ? getQueryParams.split("?")[2] : "";
  const [signupForm, setSignupForm] = useState<SIGNUP_FORM>({
    email: getMailId,
    password: "",
    confirmPassword: "",
  });

  const [isServerErr, setIsServerErr] = useState({
    successRes: "",
    failedRes: "",
    limitExceeded: "",
  });

  const [signupFormErr, setSignupFormErr] = useState<SIGNUP_FORM>({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const submitSignupForm = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await getServerKey(getServerTokenRes);
  };
  const getServerTokenRes = async (res: any, newResp: any) => {
    var SPK = newResp.headers.get("SPK");
    if (res && res.error) {
      setIsServerErr({
        successRes: "",
        failedRes: errorsMsg.commonError,
        limitExceeded: "",
      });
    } else {
      const hashPassword = await hashingFeatures(signupForm.password);
      let jsonData = JSON.stringify({
        user: {
          userName: signupForm.email,
          password: hashPassword,
          leadID: getLeadId ? getLeadId : "",
          name: getName ? getName : "",
        },
        client: keyClockclient,
      });
      // Here we are encrypt the data
      let encrypedForm = await encryption(SPK, jsonData);
      vendorSignFormSubmit(
        submitSignupFormRes,
        encrypedForm.reqObj,
        encrypedForm.header
      );
    }
  };
  const submitSignupFormRes = async (res: any, newResp: any) => {
    if (res && res.error) {
      setIsServerErr({
        successRes: "",
        failedRes: res.error.errorMessage || errorsMsg.commonError,
        limitExceeded: "",
      });
    } else if (res && res.response) {
      let CEPRK = newResp.headers.get("CEPRK");
      let decryptedData = await decryption(CEPRK, res.response);
      if (decryptedData && decryptedData.status) {
        setSignupForm({
          email: "",
          password: "",
          confirmPassword: "",
        });
        setIsServerErr({
          successRes: decryptedData.data.message,
          failedRes: "",
          limitExceeded: "",
        });
      }
    } else {
      setIsServerErr({
        successRes: "",
        failedRes: errorsMsg.commonError,
        limitExceeded: "",
      });
    }
  };

  const removeIsServerErrors = () => {
    setIsServerErr({
      successRes: "",
      failedRes: "",
      limitExceeded: "",
    });
  };

  useEffect(() => {
    if (isServerErr.successRes !== "" || isServerErr.failedRes !== "") {
      removeServerErrors(removeIsServerErrors, constants.ErrorTimeout);
    }
  }, [isServerErr]);

  return (
    <div>
      <ErrorMsg isServerErr={isServerErr} />
      <div className="vendor-signup">
        <div className="vendor-signup-left">
          <div className="logo-section">
            <img src={NuvamaWhiteLogo} alt="Nuvama-White-Logo" />
            <div className="mob-close">
              <span>
                <i
                  onClick={() => history.push(RoutesUrl.Home)}
                  className="edel-icon-close"
                ></i>
              </span>
            </div>
          </div>
          <div className="vendor-signup-left-content">
            <div className="left-content-box">
              <p>Welcome to</p>
              <h1>Nuvama API Connect</h1>
            </div>
          </div>
        </div>
        <div className="vendor-signup-right">
          <div className="deshtop-close">
            <span>
              <i
                className="edel-icon-close"
                onClick={() => history.push(RoutesUrl.Home)}
              ></i>
            </span>
          </div>
          <div className="set-account-details">
            <div className="set-account-details-header">
              <h3>Set Account Details</h3>
              <p>Please mention the details for your account</p>
            </div>
            <VendorSignup
              signupForm={signupForm}
              setSignupForm={setSignupForm}
              signupFormErr={signupFormErr}
              setSignupFormErr={setSignupFormErr}
              submitSignupForm={submitSignupForm}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
